import { render, staticRenderFns } from "./Paging.vue?vue&type=template&id=377342ca&scoped=true"
import script from "./Paging.vue?vue&type=script&lang=ts"
export * from "./Paging.vue?vue&type=script&lang=ts"
import style0 from "./Paging.vue?vue&type=style&index=0&id=377342ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "377342ca",
  null
  
)

export default component.exports